import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { UsersService } from 'src/app/shared/services/users.service';
import { CompaniesService } from 'src/app/shared/services/companies.service';
import { UtilitiesService } from 'src/app/shared/services/utilities.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-report-cards',
  templateUrl: './report-cards.component.html',
  styleUrls: ['./report-cards.component.scss']
})
export class ReportCardsComponent implements OnInit {
  public subscriptions: Subscription[] = [];
  public userData: any;
  public users: any[] = [];
  public companies: {id: string, companyName: string}[];

  public filters: {
    companyId: number
  }
  public companyEditorOptions;

  constructor(
    private utilitiesService: UtilitiesService,
    private companies_service: CompaniesService,
    private users_service: UsersService,
    private router: Router
  ) {
    this.userData = this.utilitiesService.getUserData();

    this.companyEditorOptions = { 
      dataSource: this.companies, 
      valueExpr: 'companyName',
      displayExpr: 'companyId',
    };

    this.filters = {
      companyId: null
    }
  }

  ngOnInit() {
    if(this.userData.level < 4) {
      this.getCompanies();
    } else {
      this.filters.companyId = this.userData.companyId;
    }
  }

  getCompanies() {
    this.companies_service.getCompanies().subscribe(
      (res: any) => {
        console.log(res);
        this.companies = res;
        this.companies.unshift({id: '0', companyName: 'Sleccionar Empresa'});
      },
      error => {
        console.log(error);
    });
  }
  getUsersCards() {
    this.companies_service.getCards(this.filters.companyId).subscribe(
      result => {
        console.log(result);
        this.users = result;
      },
      error => {
        console.log(error);
      }
    );
  }

  onChangeCompany(e) {
    this.getUsersCards();
  }
  onRowPrepared(e) {
    /*if (e.rowType == "data" && (`${e.data?.urls || ''}`.trim() == "")) {
      e.rowElement.querySelector(".dx-command-expand").firstChild.classList.remove("dx-datagrid-group-closed");
    }*/ 
  }
  goTo(_route) {
    this.router.navigate(_route);
  }

}
